import React from 'react';
import { ArrowRight, Linkedin } from 'lucide-react';
import { brandData } from '../mock';

export default function Rebrand() {
  return (
    <section className="relative border-t border-black/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-28">
        <div className="text-[10px] tracking-[0.28em] uppercase text-neutral-500 mb-5">
          The Rebrand
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-end mb-14">
          <h2 className="md:col-span-2 font-serif text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.02em] text-neutral-900">
            A new chapter, <span className="italic text-neutral-500">side by side.</span>
          </h2>
          <p className="text-neutral-600 text-[15px] leading-relaxed max-w-sm">
            The same people, the same mission — with a sharper editorial
            voice built for what comes next.
          </p>
        </div>

        <div className="relative grid md:grid-cols-2 gap-5 md:gap-6">
          {/* Before card */}
          <div className="relative rounded-md bg-white border border-black/5 shadow-sm p-8 md:p-10 min-h-[420px] flex flex-col">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#EA580C] mb-6">
              Before
            </div>
            <div className="flex-1 flex items-center justify-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-md bg-white border border-black/5 overflow-hidden flex items-center justify-center shadow-md p-3">
                <img
                  src={brandData.before.logo}
                  alt="Confidential logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <div className="hairline my-6" />
            <div>
              <h3 className="font-serif text-[26px] md:text-[28px] text-neutral-900 tracking-tight">
                {brandData.before.name}
              </h3>
              <p className="mt-2 text-neutral-600 text-[14.5px] leading-relaxed">
                {brandData.before.tagline}
              </p>
              <a
                href={brandData.before.linkedin}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex items-center gap-2 border border-neutral-300 hover:border-neutral-900 text-[11px] tracking-[0.22em] uppercase px-4 py-2.5 rounded-sm transition-colors"
              >
                <Linkedin className="w-3.5 h-3.5" /> Visit LinkedIn
              </a>
            </div>
          </div>

          {/* Middle divider with arrow (desktop) */}
          <div className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 flex-col items-center pointer-events-none">
            <div className="flex-1 w-px bg-black/10" />
            <div className="w-11 h-11 rounded-full bg-[#EA580C] text-[#F5F2EC] flex items-center justify-center shadow-md pointer-events-auto">
              <ArrowRight className="w-5 h-5" />
            </div>
            <div className="mt-2 text-[11px] italic text-neutral-500 font-serif">is now</div>
            <div className="flex-1 w-px bg-black/10" />
          </div>

          {/* Now card (dark) */}
          <div className="relative rounded-md bg-neutral-900 text-[#F5F2EC] shadow-lg p-8 md:p-10 min-h-[420px] flex flex-col">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#EA580C] mb-6">
              Now
            </div>
            <div className="flex-1 flex items-center justify-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-md bg-neutral-950 overflow-hidden flex items-center justify-center shadow-md">
                <img
                  src={brandData.now.logo}
                  alt="Startup Culture logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <div className="h-px my-6 bg-white/10" />
            <div>
              <h3 className="font-serif text-[26px] md:text-[28px] tracking-tight">
                {brandData.now.name}
              </h3>
              <p className="mt-2 text-neutral-300 text-[14.5px] leading-relaxed">
                {brandData.now.tagline}
              </p>
              <a
                href={brandData.now.linkedin}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex items-center gap-2 border border-white/30 hover:border-[#EA580C] hover:text-[#EA580C] text-[11px] tracking-[0.22em] uppercase px-4 py-2.5 rounded-sm transition-colors"
              >
                <Linkedin className="w-3.5 h-3.5" /> Visit LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
